import React from "react";
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';


function MatButton({
   className,
   btnText,
   isLoading,
   ...props
}) {
   return (
      <>
         <Button
            variant="contained"
            className={className}
            {...props}
         >
            {btnText}
            {isLoading ? (
               <CircularProgress
                  size={16}
                  className='custom-spinner'
                  thickness={5}
               />
            ) : null}
         </Button>
      </>
   );
}


export default MatButton;